var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 10.8332C10.4615 10.8332 10.8346 10.4601 10.8346 9.99984C10.8346 9.5396 10.4615 9.1665 10.0013 9.1665C9.54106 9.1665 9.16797 9.5396 9.16797 9.99984C9.16797 10.4601 9.54106 10.8332 10.0013 10.8332Z",
    fill: "#D9D9D9",
    stroke: "#D1D2D7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 5.00016C10.4615 5.00016 10.8346 4.62707 10.8346 4.16683C10.8346 3.70659 10.4615 3.3335 10.0013 3.3335C9.54106 3.3335 9.16797 3.70659 9.16797 4.16683C9.16797 4.62707 9.54106 5.00016 10.0013 5.00016Z",
    fill: "#D9D9D9",
    stroke: "#D1D2D7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 16.6667C10.4615 16.6667 10.8346 16.2936 10.8346 15.8333C10.8346 15.3731 10.4615 15 10.0013 15C9.54106 15 9.16797 15.3731 9.16797 15.8333C9.16797 16.2936 9.54106 16.6667 10.0013 16.6667Z",
    fill: "#D9D9D9",
    stroke: "#D1D2D7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDots);
export default __webpack_public_path__ + "static/media/vertical-dots.570d655c8338a33c5967278957e8c65b.svg";
export { ForwardRef as ReactComponent };